import React, { useState } from 'react';

const ScheduledOrderModal = ({ portfolioItem, onClose, onSave, authenticatedFetch }) => {
  const [formData, setFormData] = useState({
    symbol: portfolioItem?.symbol || '',
    stock_name: portfolioItem?.name || portfolioItem?.stock_name || '',
    order_type: 'buy',
    quantity: '',
    price: '',
    order_method: 'limit',
    scheduled_time: '',
    repeat_type: 'none',
    repeat_interval: 1,
    repeat_end_date: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.symbol || !formData.quantity || !formData.price || !formData.scheduled_time) {
      alert('필수 필드를 모두 입력해주세요.');
      return;
    }

    setLoading(true);
    try {
      const response = await authenticatedFetch('/api/portfolio/scheduled-orders', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        const data = await response.json();
        alert(data.message || '예약 주문이 생성되었습니다.');
        onSave();
      } else {
        const error = await response.json();
        alert(error.error || '예약 주문 생성에 실패했습니다.');
      }
    } catch (error) {
      console.error('예약 주문 생성 실패:', error);
      alert('예약 주문 생성에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      if (onClose) onClose();
    }
  };

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10000,
        paddingTop: '80px', // 헤더 높이만큼 상단 여백 추가
        boxSizing: 'border-box'
      }}
      onClick={handleOverlayClick}
    >
      <div 
        style={{
          backgroundColor: 'white',
          padding: '30px',
          borderRadius: '8px',
          maxWidth: '600px',
          width: '90%',
          maxHeight: 'calc(100vh - 100px)', // 헤더 높이 고려하여 조정
          overflow: 'auto',
          position: 'relative',
          marginTop: 'auto',
          marginBottom: 'auto'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ margin: 0 }}>📅 예약 주문 생성</h2>
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (onClose) onClose();
            }}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '28px',
              color: '#999',
              cursor: 'pointer',
              padding: '0',
              width: '30px',
              height: '30px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              lineHeight: '1'
            }}
            aria-label="닫기"
          >
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '15px' }}>
            <label>종목코드 *</label>
            <input
              type="text"
              value={formData.symbol}
              onChange={(e) => setFormData({ ...formData, symbol: e.target.value })}
              required
              style={{ width: '100%', padding: '8px' }}
              placeholder="예: 005930"
            />
          </div>
          <div style={{ marginBottom: '15px' }}>
            <label>종목명</label>
            <input
              type="text"
              value={formData.stock_name}
              onChange={(e) => setFormData({ ...formData, stock_name: e.target.value })}
              style={{ width: '100%', padding: '8px' }}
              placeholder="예: 삼성전자"
            />
          </div>
          <div style={{ marginBottom: '15px' }}>
            <label>주문 유형 *</label>
            <select
              value={formData.order_type}
              onChange={(e) => setFormData({ ...formData, order_type: e.target.value })}
              style={{ width: '100%', padding: '8px' }}
            >
              <option value="buy">매수</option>
              <option value="sell">매도</option>
            </select>
          </div>
          <div style={{ marginBottom: '15px' }}>
            <label>수량 (주) *</label>
            <input
              type="number"
              value={formData.quantity}
              onChange={(e) => setFormData({ ...formData, quantity: e.target.value })}
              required
              min="1"
              style={{ width: '100%', padding: '8px' }}
            />
          </div>
          <div style={{ marginBottom: '15px' }}>
            <label>가격 (원) *</label>
            <input
              type="number"
              value={formData.price}
              onChange={(e) => setFormData({ ...formData, price: e.target.value })}
              required
              min="0"
              step="1"
              style={{ width: '100%', padding: '8px' }}
            />
          </div>
          <div style={{ marginBottom: '15px' }}>
            <label>주문 방법</label>
            <select
              value={formData.order_method}
              onChange={(e) => setFormData({ ...formData, order_method: e.target.value })}
              style={{ width: '100%', padding: '8px' }}
            >
              <option value="limit">지정가</option>
              <option value="market">시장가</option>
            </select>
          </div>
          <div style={{ marginBottom: '15px' }}>
            <label>예약 시간 *</label>
            <input
              type="datetime-local"
              value={formData.scheduled_time}
              onChange={(e) => setFormData({ ...formData, scheduled_time: e.target.value })}
              required
              style={{ width: '100%', padding: '8px' }}
            />
          </div>
          <div style={{ marginBottom: '15px' }}>
            <label>반복 설정</label>
            <select
              value={formData.repeat_type}
              onChange={(e) => setFormData({ ...formData, repeat_type: e.target.value })}
              style={{ width: '100%', padding: '8px' }}
            >
              <option value="none">반복 없음</option>
              <option value="daily">매일</option>
              <option value="weekly">매주</option>
              <option value="monthly">매월</option>
            </select>
          </div>
          {formData.repeat_type !== 'none' && (
            <>
              <div style={{ marginBottom: '15px' }}>
                <label>반복 간격</label>
                <input
                  type="number"
                  value={formData.repeat_interval}
                  onChange={(e) => setFormData({ ...formData, repeat_interval: parseInt(e.target.value) || 1 })}
                  min="1"
                  style={{ width: '100%', padding: '8px' }}
                />
                <small style={{ color: '#666' }}>예: 2 입력 시 매 2일/2주/2개월마다 실행</small>
              </div>
              <div style={{ marginBottom: '15px' }}>
                <label>반복 종료 날짜</label>
                <input
                  type="date"
                  value={formData.repeat_end_date}
                  onChange={(e) => setFormData({ ...formData, repeat_end_date: e.target.value })}
                  style={{ width: '100%', padding: '8px' }}
                />
              </div>
            </>
          )}
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              style={{ padding: '10px 20px', backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
            >
              취소
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{ padding: '10px 20px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
            >
              {loading ? '생성 중...' : '생성'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};


export default ScheduledOrderModal;
